module.exports = __webpack_public_path__ + "static/media/31-7.43335199.mp3";